/**
 * ClemtexSearch — shopping entry point.
 *
 * Three independent, frontend-only tweaks to SuiteCommerce search. Each one
 * is mounted inside its own try/catch so a failure in one can never take the
 * others (or the site) down.
 *
 *  - TypeaheadSku : item number under each type-ahead suggestion
 *  - SkuRanking   : exact/prefix item-number matches jump above the
 *                   best-seller (custitem_rank) order in the type-ahead
 *  - SkuJump      : a keyword search that IS an item number goes straight to
 *                   the product page instead of the results list
 *
 * All three work at the jQuery AJAX layer (prefilters / a transport) on the
 * Item Search API calls the core already makes. They require only public
 * core modules (jQuery, underscore, Backbone), so SuiteCommerce Safe Mode
 * (Advanced > Extensions) loads them without warnings, and the Manor theme's
 * own typeahead template — including its inline "Categories" script — is
 * left untouched.
 */
define('Clemtex.Search', [
    'Clemtex.Search.TypeaheadSku',
    'Clemtex.Search.SkuRanking',
    'Clemtex.Search.SkuJump'
], function (TypeaheadSku, SkuRanking, SkuJump) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            [TypeaheadSku, SkuRanking, SkuJump].forEach(function (module) {
                try {
                    module.mountToApp(container);
                } catch (e) {
                    if (window.console) { window.console.error('ClemtexSearch mount failed', e); }
                }
            });
        }
    };
});
